module.exports = __webpack_public_path__ + "img/sec_in_device4.4eeb1cb7.png";